var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.model.sale_id)?_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.setDelete}},[_c('i',{staticClass:"icon-trash"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }